import { FC, useEffect, useRef, useState } from 'react'
import { useSession } from 'next-auth/react'
import { getBrowserAnalyticsService } from '~/modules/Analytics/Infrastructure/safeAnalytics'

/**
 * React component that identifies an authenticated user in the browser
 * analytics runtime without leaking PII to downstream tags.
 */
export const AnalyticsIdentify: FC = () => {
  const session = useSession()
  const [lastIdentifiedUserId, setLastIdentifiedUserId] = useState<string | null>(null)
  const pendingUserIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (session.status !== 'authenticated') {
      pendingUserIdRef.current = null
      setLastIdentifiedUserId(null)

      return
    }

    const analyticsService = getBrowserAnalyticsService()
    const user = session.data.user

    if (
      analyticsService === null ||
      !user.email ||
      !user.name ||
      user.id === lastIdentifiedUserId ||
      user.id === pendingUserIdRef.current
    ) {
      return
    }

    pendingUserIdRef.current = user.id

    void analyticsService.identify({
      createdAt: user.createdAt ?? '',
      email: user.email,
      id: user.id,
      name: user.name,
    }).then(() => {
      pendingUserIdRef.current = null
      setLastIdentifiedUserId(user.id)
    }).catch(() => {
      pendingUserIdRef.current = null
    })
  }, [lastIdentifiedUserId, session.data, session.status])

  return (<></>)
}
